// TODO Improvement: Have files using this use the countries.yml 
// and country.rb model as the source of truth instead of this file
export const countries = [
  { id: 0, label: 'Other', isEu: false  },
  { id: 1, label: 'United States', isEu: false },
  { id: 40, label: 'American Samoa', isEu: false },
  { id: 39, label: '\u00c5land Islands', isEu: false },
  { id: 41, label: 'Antarctica', isEu: false },
  { id: 6, label: 'Australia', isEu: false },
  { id: 23, label: 'Austria', isEu: true },
  { id: 2, label: 'Bahamas', isEu: false },
  { id: 29, label: 'Belgium', isEu: true },
  { id: 42, label: 'Bonaire\n Sint Eustatius\n Saba', isEu: false },
  { id: 43, label: 'Bouvet Island', isEu: false },
  { id: 44, label: 'British Indian Ocean Territory (the)', isEu: false },
  { id: 17, label: 'Bulgaria', isEu: true },
  { id: 3, label: 'Canada', isEu: false },
  { id: 37, label: 'China', isEu: false },
  { id: 45, label: 'Christmas Island', isEu: false },
  { id: 46, label: 'Cocos (Keeling) Islands (the)', isEu: false },
  { id: 47, label: 'Colombia', isEu: false },
  { id: 48, label: 'Comoros (the)', isEu: false },
  { id: 49, label: 'Congo (the Democratic Republic of the)', isEu: false },
  { id: 50, label: 'Congo (the)', isEu: false },
  { id: 51, label: 'Cook Islands (the)', isEu: false },
  { id: 52, label: 'Costa Rica', isEu: false },
  { id: 19, label: 'Croatia', isEu: true },
  { id: 54, label: 'Cuba', isEu: false },
  { id: 55, label: 'Cura\u00e7ao', isEu: false },
  { id: 28, label: 'Cyprus', isEu: true },
  { id: 21, label: 'Czech Republic', isEu: true },
  { id: 53, label: 'C\u00f4te d\'Ivoire', isEu: false },
  { id: 27, label: 'Denmark', isEu: true },
  { id: 56, label: 'Djibouti', isEu: false },
  { id: 57, label: 'Dominica', isEu: false },
  { id: 58, label: 'Dominican Republic (the)', isEu: false },
  { id: 59, label: 'Ecuador', isEu: false },
  { id: 60, label: 'Egypt', isEu: false },
  { id: 61, label: 'El Salvador', isEu: false },
  { id: 62, label: 'Equatorial Guinea', isEu: false },
  { id: 63, label: 'Eritrea', isEu: false },
  { id: 34, label: 'Estonia', isEu: true },
  { id: 64, label: 'Eswatini', isEu: false },
  { id: 65, label: 'Ethiopia', isEu: false },
  { id: 66, label: 'Falkland Islands (the) [Malvinas]', isEu: false },
  { id: 67, label: 'Faroe Islands (the)', isEu: false },
  { id: 68, label: 'Fiji', isEu: false },
  { id: 25, label: 'Finland', isEu: true },
  { id: 8, label: 'France', isEu: true },
  { id: 69, label: 'French Guiana', isEu: false },
  { id: 70, label: 'French Polynesia', isEu: false },
  { id: 71, label: 'French Southern Territories (the)', isEu: false },
  { id: 72, label: 'Gabon', isEu: false },
  { id: 73, label: 'Gambia (the)', isEu: false },
  { id: 74, label: 'Georgia', isEu: false },
  { id: 12, label: 'Germany', isEu: true },
  { id: 75, label: 'Ghana', isEu: false },
  { id: 76, label: 'Gibraltar', isEu: false },
  { id: 36, label: 'Great Britain', isEu: true },
  { id: 18, label: 'Greece', isEu: true },
  { id: 77, label: 'Greenland', isEu: false },
  { id: 78, label: 'Grenada', isEu: false },
  { id: 79, label: 'Guadeloupe', isEu: false },
  { id: 80, label: 'Guam', isEu: false },
  { id: 81, label: 'Guatemala', isEu: false },
  { id: 82, label: 'Guernsey', isEu: false },
  { id: 83, label: 'Guinea', isEu: false },
  { id: 84, label: 'Guinea-Bissau', isEu: false },
  { id: 85, label: 'Guyana', isEu: false },
  { id: 86, label: 'Haiti', isEu: false },
  { id: 87, label: 'Heard Island and McDonald Islands', isEu: false },
  { id: 88, label: 'Holy See (the)', isEu: false },
  { id: 89, label: 'Honduras', isEu: false },
  { id: 90, label: 'Hong Kong', isEu: false },
  { id: 24, label: 'Hungary', isEu: true },
  { id: 91, label: 'Iceland', isEu: false },
  { id: 92, label: 'India', isEu: false },
  { id: 93, label: 'Indonesia', isEu: false },
  { id: 94, label: 'Iran (Islamic Republic of)', isEu: false },
  { id: 95, label: 'Iraq', isEu: false },
  { id: 22, label: 'Ireland', isEu: true },
  { id: 96, label: 'Isle of Man', isEu: false },
  { id: 97, label: 'Israel', isEu: false },
  { id: 13, label: 'Italy', isEu: true },
  { id: 98, label: 'Jamaica', isEu: false },
  { id: 38, label: 'Japan', isEu: false },
  { id: 99, label: 'Jersey', isEu: false },
  { id: 100, label: 'Jordan', isEu: false },
  { id: 101, label: 'Kazakhstan', isEu: false },
  { id: 102, label: 'Kenya', isEu: false },
  { id: 103, label: 'Kiribati', isEu: false },
  { id: 104, label: 'Korea (the Democratic People\'s Republic of)', isEu: false },
  { id: 105, label: 'Korea (the Republic of)', isEu: false },
  { id: 106, label: 'Kuwait', isEu: false },
  { id: 107, label: 'Kyrgyzstan', isEu: false },
  { id: 108, label: 'Lao People\'s Democratic Republic (the)', isEu: false },
  { id: 35, label: 'Latvia', isEu: true },
  { id: 109, label: 'Lebanon', isEu: false },
  { id: 110, label: 'Lesotho', isEu: false },
  { id: 111, label: 'Liberia', isEu: false },
  { id: 112, label: 'Libya', isEu: false },
  { id: 113, label: 'Liechtenstein', isEu: false },
  { id: 31, label: 'Lithuania', isEu: true },
  { id: 114, label: 'Luxembourg', isEu: false },
  { id: 115, label: 'Macao', isEu: false },
  { id: 117, label: 'Madagascar', isEu: false },
  { id: 118, label: 'Malawi', isEu: false },
  { id: 119, label: 'Malaysia', isEu: false },
  { id: 120, label: 'Maldives', isEu: false },
  { id: 121, label: 'Mali', isEu: false },
  { id: 30, label: 'Malta', isEu: true },
  { id: 122, label: 'Marshall Islands (the)', isEu: false },
  { id: 123, label: 'Martinique', isEu: false },
  { id: 124, label: 'Mauritania', isEu: false },
  { id: 125, label: 'Mauritius', isEu: false },
  { id: 126, label: 'Mayotte', isEu: false },
  { id: 4, label: 'Mexico', isEu: false },
  { id: 127, label: 'Micronesia (Federated States of)', isEu: false },
  { id: 128, label: 'Moldova (the Republic of)', isEu: false },
  { id: 9, label: 'Monaco', isEu: false },
  { id: 129, label: 'Mongolia', isEu: false },
  { id: 130, label: 'Montenegro', isEu: false },
  { id: 131, label: 'Montserrat', isEu: false },
  { id: 132, label: 'Morocco', isEu: false },
  { id: 133, label: 'Mozambique', isEu: false },
  { id: 134, label: 'Myanmar', isEu: false },
  { id: 135, label: 'Namibia', isEu: false },
  { id: 136, label: 'Nauru', isEu: false },
  { id: 137, label: 'Nepal', isEu: false },
  { id: 20, label: 'Netherlands', isEu: true },
  { id: 138, label: 'New Caledonia', isEu: false },
  { id: 139, label: 'New Zealand', isEu: false },
  { id: 140, label: 'Nicaragua', isEu: false },
  { id: 141, label: 'Niger (the)', isEu: false },
  { id: 142, label: 'Nigeria', isEu: false },
  { id: 143, label: 'Niue', isEu: false },
  { id: 144, label: 'Norfolk Island', isEu: false },
  { id: 116, label: 'North Macedonia', isEu: false },
  { id: 145, label: 'Northern Mariana Islands (the)', isEu: false },
  { id: 146, label: 'Norway', isEu: false },
  { id: 147, label: 'Oman', isEu: false },
  { id: 148, label: 'Pakistan', isEu: false },
  { id: 149, label: 'Palau', isEu: false },
  { id: 150, label: 'Palestine, State of', isEu: false },
  { id: 151, label: 'Panama', isEu: false },
  { id: 152, label: 'Papua New Guinea', isEu: false },
  { id: 153, label: 'Paraguay', isEu: false },
  { id: 154, label: 'Peru', isEu: false },
  { id: 155, label: 'Philippines (the)', isEu: false },
  { id: 156, label: 'Pitcairn', isEu: false },
  { id: 14, label: 'Poland', isEu: true },
  { id: 26, label: 'Portugal', isEu: true },
  { id: 157, label: 'Puerto Rico', isEu: false },
  { id: 158, label: 'Qatar', isEu: false },
  { id: 15, label: 'Romania', isEu: true },
  { id: 160, label: 'Russian Federation (the)', isEu: false },
  { id: 161, label: 'Rwanda', isEu: false },
  { id: 159, label: 'R\u00e9union', isEu: false },
  { id: 162, label: 'Saint Barth\u00e9lemy', isEu: false },
  { id: 163, label: 'Saint Helena\n Ascension Island\n Tristan da Cunha', isEu: false },
  { id: 164, label: 'Saint Kitts and Nevis', isEu: false },
  { id: 165, label: 'Saint Lucia', isEu: false },
  { id: 166, label: 'Saint Martin (French part)', isEu: false },
  { id: 167, label: 'Saint Pierre and Miquelon', isEu: false },
  { id: 168, label: 'Saint Vincent and the Grenadines', isEu: false },
  { id: 169, label: 'Samoa', isEu: false },
  { id: 170, label: 'San Marino', isEu: false },
  { id: 171, label: 'Sao Tome and Principe', isEu: false },
  { id: 172, label: 'Saudi Arabia', isEu: false },
  { id: 173, label: 'Senegal', isEu: false },
  { id: 174, label: 'Serbia', isEu: false },
  { id: 175, label: 'Seychelles', isEu: false },
  { id: 176, label: 'Sierra Leone', isEu: false },
  { id: 177, label: 'Singapore', isEu: false },
  { id: 178, label: 'Sint Maarten (Dutch part)', isEu: false },
  { id: 33, label: 'Slovakia', isEu: true },
  { id: 32, label: 'Slovenia', isEu: true },
  { id: 179, label: 'Solomon Islands', isEu: false },
  { id: 180, label: 'Somalia', isEu: false },
  { id: 181, label: 'South Africa', isEu: false },
  { id: 182, label: 'South Georgia and the South Sandwich Islands', isEu: false },
  { id: 183, label: 'South Sudan', isEu: false },
  { id: 10, label: 'Spain', isEu: true },
  { id: 184, label: 'Sri Lanka', isEu: false },
  { id: 185, label: 'Sudan (the)', isEu: false },
  { id: 186, label: 'Suriname', isEu: false },
  { id: 187, label: 'Svalbard\n Jan Mayen', isEu: false },
  { id: 16, label: 'Sweden', isEu: true },
  { id: 7, label: 'Switzerland', isEu: false },
  { id: 188, label: 'Syrian Arab Republic (the)', isEu: false },
  { id: 189, label: 'Taiwan (Province of China)', isEu: false },
  { id: 190, label: 'Tajikistan', isEu: false },
  { id: 191, label: 'Tanzania, the United Republic of', isEu: false },
  { id: 192, label: 'Thailand', isEu: false },
  { id: 193, label: 'Timor-Leste', isEu: false },
  { id: 194, label: 'Togo', isEu: false },
  { id: 195, label: 'Tokelau', isEu: false },
  { id: 196, label: 'Tonga', isEu: false },
  { id: 197, label: 'Trinidad and Tobago', isEu: false },
  { id: 198, label: 'Tunisia', isEu: false },
  { id: 5, label: 'Turkey', isEu: false },
  { id: 199, label: 'Turkmenistan', isEu: false },
  { id: 200, label: 'Turks and Caicos Islands (the)', isEu: false },
  { id: 201, label: 'Tuvalu', isEu: false },
  { id: 202, label: 'Uganda', isEu: false },
  { id: 203, label: 'Ukraine', isEu: false },
  { id: 204, label: 'United Arab Emirates (the)', isEu: false },
  { id: 11, label: 'United Kingdom', isEu: true },
  { id: 205, label: 'United States Minor Outlying Islands (the)', isEu: false },
  { id: 206, label: 'Uruguay', isEu: false },
  { id: 207, label: 'Uzbekistan', isEu: false },
  { id: 208, label: 'Vanuatu', isEu: false },
  { id: 209, label: 'Venezuela (Bolivarian Republic of)', isEu: false },
  { id: 210, label: 'Viet Nam', isEu: false },
  { id: 211, label: 'Virgin Islands (British)', isEu: false },
  { id: 212, label: 'Virgin Islands (U.S.)', isEu: false },
  { id: 213, label: 'Wallis and Futuna', isEu: false },
  { id: 214, label: 'Western Sahara', isEu: false },
  { id: 215, label: 'Yemen', isEu: false },
  { id: 216, label: 'Zambia', isEu: false },
  { id: 217, label: 'Zimbabwe', isEu: false }
];


export function isEuCountry(countryId) {
  const country = countries.find(c => c.id === Number(countryId));
  return country ? country.isEu : false;
}

export function getUnitedStatesId() {
  return 1;
}

export function getUnitedKingdomId() {
  return 11;
}
